import React from "react";
import { NavLink, Link } from "react-router-dom";
import { BsFacebook } from "react-icons/bs";
import { FaPhoneVolume, FaMapMarked, FaYoutube } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import { IoSearchSharp } from "react-icons/io5";
import { BsPerson } from "react-icons/bs";
import DateDisplay from "./DateDisplay";
import "./style.css";


const Navbar = () => {
  
  return (
    <>
      {/* <div style={{ background: "#304E50", padding: "20px" }}>
        <div className=" d-flex justify-content-between align-items-center flex-wrap text-dark">
          
          <div className="d-flex flex-wrap gap-3">
            <Link to="$" style={{ color: "#fff" }}>
            </Link>
            <Link to="$" style={{ color: "#fff" }}>
            </Link>
            <Link to="$" style={{ color: "#fff" }}>
            </Link>
            <Link to="$" style={{ color: "#c49a6c", fontSize:"24px" }}>
              <IoSearchSharp />
            </Link>
          </div>
          <div className="d-flex gap-3">
            <DateDisplay />
          </div>
        </div>
      </div> */}

      <nav className="navbar navbar-expand-lg bg-white shadow-sm" dir="rtl">
        <div className="container">
          <NavLink className="navbar-brand" to="https://mjc.edu.sa/">
            <img src="ma.jpg" alt="شعار" style={{ width: "300px" }} />
          </NavLink>

          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          {/* Menu */}
          {/* <div
            className="collapse navbar-collapse justify-content-center"
            id="navbarNav"
          >
            <ul className="navbar-nav">
              <li className="nav-item px-2">
                <NavLink
                  className="nav-link text-dark"
                  to="https://mjc.edu.sa/"
                >
                  الرئيسية
                </NavLink>
              </li>
              <li className="nav-item dropdown px-2 custom-dropdown">
                <NavLink
                  className="nav-link text-dark"
                  to="https://mjc.edu.sa/about-us-ar/"
                >
                  <span>عن الكلية</span>
                </NavLink>
                <ul className="dropdown-menu custom-menu">
                  <li>
                    <NavLink
                      className="dropdown-item"
                      to="https://mjc.edu.sa/vision-mision/"
                    >
                      الرؤية والرسالة
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      className="dropdown-item"
                      to="https://mjc.edu.sa/deans-speech/"
                    >
                      كلمة عميد الكلية
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      className="dropdown-item"
                      to="https://mjc.edu.sa/strategic-planning-ar/"
                    >
                      الخطة الإستراتيجية
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      className="dropdown-item"
                      to="https://mjc.edu.sa/social-responsibility-ar/"
                    >
                      المسؤولية المجتمعية
                    </NavLink>
                  </li>
                  <li>
                    <NavLink className="dropdown-item" to="https://orangered-caterpillar-389990.hostingersite.com/administrative-organization/">
                      التنظيم الإداري
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      className="dropdown-item"
                      to="https://mjc.edu.sa/organizational-structure/"
                    >
                      الهيكل التنظيمي
                    </NavLink>
                  </li>
                </ul>
              </li>

              <li className="nav-item dropdown px-2 custom-dropdown">
                <a
                  className="nav-link dropdown-toggle text-dark"
                  href="#"
                  id="departmentsDropdown"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  البرامج الدراسية
                </a>
                <ul
                  className="dropdown-menu text-end"
                  aria-labelledby="departmentsDropdown"
                >
                  <li>
                    <NavLink
                      className="dropdown-item text-dark"
                      to="https://mjc.edu.sa/business-administration-ar/"
                    >
                      إدارة الأعمال
                    </NavLink>
                  </li>
                  <li className="dropdown-submenu">
                    <NavLink
                      className="dropdown-item dropdown-toggle text-dark bg-white"
                      to="#"
                      onClick={(e) => e.preventDefault()}
                    >
                      إدارة الأعمال
                    </NavLink>
                    <ul className="dropdown-menu submenu-list">
                      <li>
                        <NavLink
                          className="dropdown-item text-dark"
                          to="https://mjc.edu.sa/business-administration-ar/"
                        >
                          إدارة الأعمال
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          className="dropdown-item"
                          to="https://mjc.edu.sa/hr-management/"
                        >
                          الموارد البشرية
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          className="dropdown-item"
                          to="https://mjc.edu.sa/supply-chain/"
                        >
                          إدارة سلاسل الإمداد
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          className="dropdown-item"
                          to="https://mjc.edu.sa/digital-marketing/"
                        >
                          التسويق الرقمي
                        </NavLink>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <NavLink
                      className="dropdown-item text-dark"
                      to="https://mjc.edu.sa/law-program-ar/"
                    >
                      برنامج الحقوق
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      className="dropdown-item text-dark"
                      to="https://mjc.edu.sa/accounting-program-ar/"
                    >
                      برنامج المحاسبة
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      className="dropdown-item text-dark"
                      to="https://mjc.edu.sa/early-childhood-program-ar/"
                    >
                      برنامج الطفولة المبكرة
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      className="dropdown-item text-dark"
                      to="https://mjc.edu.sa/computer-science/"
                    >
                      علوم الحاسوب
                    </NavLink>
                  </li>
                  <li className="dropdown-submenu submenu-left">
  <NavLink
    className="dropdown-item dropdown-toggle text-dark bg-white"
    to="https://mjc.edu.sa/computer-science/"
    onClick={(e) => e.preventDefault()}
  >
                      علوم الحاسوب
  </NavLink>
  <ul className="dropdown-menu submenu-list">
    <li >
      <NavLink className="dropdown-item" to="https://mjc.edu.sa/comming-soon/">
      علوم الحاسوب
      </NavLink>
    </li>
    <li >
      <NavLink className="dropdown-item" to="https://mjc.edu.sa/comming-soon/">
        الأمن السيبراني
      </NavLink>
    </li>
    <li >
      <NavLink className="dropdown-item" to="https://mjc.edu.sa/comming-soon/">
        الذكاء الأصطناعي
      </NavLink>
    </li>
  </ul>
</li>
                  <li>
                    <NavLink
                      className="dropdown-item text-dark"
                      to="https://mjc.edu.sa/electrical-engineering/"
                    >
                      الهندسة الكهربائية
                    </NavLink>
                  </li>
                  <li className="dropdown-submenu submenu-left">
  <NavLink
    className="dropdown-item dropdown-toggle text-dark bg-white"
    to="https://mjc.edu.sa/electrical-engineering/"
    onClick={(e) => e.preventDefault()}
  >
    الهندسة الكهربائية
  </NavLink>
  <ul className="dropdown-menu submenu-list">
    <li >
      <NavLink className="dropdown-item" to="https://mjc.edu.sa/comming-soon/">
        مسار القوى الكهربائية
      </NavLink>
    </li>
    <li >
      <NavLink className="dropdown-item" to="https://mjc.edu.sa/comming-soon/">
        مسار الطاقة المتجددة
      </NavLink>
    </li>
  </ul>
</li>

                  <li>
                    <NavLink
                      className="dropdown-item text-dark"
                      to="https://mjc.edu.sa/civil-engineering/"
                    >
                      برنامج الهندسة المدنية
                    </NavLink>
                  </li>
                </ul>
              </li>

              <li className="nav-item px-2">
                <NavLink
                  className="nav-link text-dark"
                  to="hhttps://mjc.edu.sa/services-ar/"
                >
                  الخدمات الإلكترونية
                </NavLink>
              </li>
              <li className="nav-item px-2">
                <NavLink
                  className="nav-link"
                  style={{ color: "#c49a6c" }}
                  to="https://mjc.edu.sa/terms-conditions/"
                >
                  القبول
                </NavLink>
              </li>
              <li className="nav-item px-2">
                <NavLink
                  className="nav-link text-dark"
                  to="https://mjc.edu.sa/contact-us-ar/"
                >
                  تواصل معنا
                </NavLink>
              </li>
            </ul>
          </div> */}

          {/* Login Button */}
          {/* <div className="d-none d-lg-block">
            <a
              href="https://test-manar-alganoub.areez.co/en/web/login"
              className="nav-link login-button"
              style={{background:"#304E50"}}
            >
              <BsPerson className="ms-2" />
              تسجيل الدخول
            </a>
          </div> */}
        </div>
      </nav>
    </>
  );
};

export default Navbar;
